<template>
  <div>Останні документи</div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
